import { DiscountProvider } from "@redotech/cockroachdb-codegen/congodb/discount-provider";
import { DiscountCategory } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import { CombineDiscountWithField } from "./fields/combine-discount-with-field";
import { CustomerEligibilityField } from "./fields/customer-eligibility-field";
import { DiscountAmountField } from "./fields/discount-amount-field";
import { ExpirationField } from "./fields/expiration-field";
import { ItemRestrictionsField } from "./fields/item-restrictions-field";
import { LimitOncePerCustomerField } from "./fields/limit-once-per-customer-field";
import { MinimumPurchaseAmountField } from "./fields/minimum-purchase-amount-field";
import { MinimumQuantityField } from "./fields/minimum-quantity-field";
import { PurchaseTypeField } from "./fields/purchase-type-field";
import { ShowHiddenRecoverFieldsField } from "./fields/show-hidden-recover-fields-field";
import { StartDateTimeField } from "./fields/start-date-time-field";
import { TotalUsesField } from "./fields/total-uses-field";
import { DiscountSettingsSectionProps } from "./types";

export function ShopifyBasicSettings({
  formState,
  category,
  showHiddenRecoverFields,
  setShowHiddenRecoverFields,
}: DiscountSettingsSectionProps) {
  const isRecover = category === DiscountCategory.RECOVER;
  const showRecoverGatedFields = !isRecover || showHiddenRecoverFields;

  return (
    <>
      <DiscountAmountField
        amount={formState.discountAmount}
        setAmount={formState.setDiscountAmount}
        setValueType={formState.setDiscountValueType}
        valueType={formState.discountValueType}
      />
      <CombineDiscountWithField
        setValue={formState.setCombineDiscountWith}
        showProductDiscounts
        showShippingDiscount
        value={formState.combineDiscountWith}
      />
      {showRecoverGatedFields && (
        <ItemRestrictionsField
          collectionIds={formState.collectionIds}
          excludeOnSale={formState.excludeOnSale}
          onExcludeOnSale={formState.handleSetExcludeOnSale}
          onSpecifyCollections={formState.handleSetSpecifyCollections}
          onSpecifyProducts={formState.handleSetSpecifyProducts}
          provider={DiscountProvider.Shopifydiscount}
          selectedProducts={formState.selectedProducts}
          setCollectionIds={formState.setCollectionIds}
          setSelectedProducts={formState.setSelectedProducts}
          specifyCollections={formState.specifyCollections}
          specifyProducts={formState.specifyProducts}
        />
      )}
      <ExpirationField
        category={category}
        codeGenerationStrategy={formState.codeGenerationStrategy}
        expiration={formState.expiration}
        setExpiration={formState.setExpiration}
      />
      {!isRecover && (
        <StartDateTimeField
          setStartDate={formState.setStartDate}
          setStartTime={formState.setStartTime}
          startDate={formState.startDate}
          startTime={formState.startTime}
        />
      )}
      {showRecoverGatedFields && (
        <>
          <MinimumQuantityField
            setValue={formState.handleSetMinimumQuantity}
            value={formState.minimumQuantity}
          />
          <MinimumPurchaseAmountField
            setValue={formState.handleSetMinimumSubtotal}
            value={formState.minimumSubtotal}
          />
        </>
      )}
      {!isRecover && (
        <>
          <CustomerEligibilityField
            eligibility={formState.customerEligibility}
            onSegmentChange={formState.handleShopifySegmentChange}
            segmentOptions={formState.ShopifySegmentOptions}
            selectedCustomerIds={formState.selectedCustomerIds}
            selectedSegmentOptions={formState.selectedShopifySegmentOptions}
            setEligibility={formState.setCustomerEligibility}
            setSelectedCustomerIds={(customerIds) => {
              formState.setSelectedCustomerIdsString(customerIds.join(", "));
            }}
          />
          <LimitOncePerCustomerField
            setValue={formState.setAppliesOncePerCustomer}
            value={formState.appliesOncePerCustomer}
          />
        </>
      )}
      <TotalUsesField
        perCode={formState.perCodeDiscount}
        setUnlimited={formState.setUnlimitedUsage}
        setValue={formState.setTotalUsageLimit}
        unlimited={formState.unlimitedUsage}
        value={formState.totalUsageLimit}
      />
      <PurchaseTypeField
        purchaseType={formState.purchaseType}
        recurringCycleLimit={formState.recurringCycleLimit}
        setPurchaseType={formState.setPurchaseType}
        setRecurringCycleLimit={formState.setRecurringCycleLimit}
      />
      {isRecover && (
        <ShowHiddenRecoverFieldsField
          setValue={setShowHiddenRecoverFields}
          value={showHiddenRecoverFields}
        />
      )}
    </>
  );
}
